var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from "react";
import { CHIP, CHIP_LABEL } from "../../classConstants";
import { getClassName } from "../../helpers";
import styled from "styled-components";
export var createChip = function (Left) {
    if (Left === void 0) { Left = function () { return null; }; }
    return styled(memo(function (_a) {
        var label = _a.label, leftProps = _a.leftProps, props = __rest(_a, ["label", "leftProps"]);
        return (React.createElement(ChipSpan, __assign({ title: label }, props, { className: getClassName(props.className, CHIP) }),
            React.createElement(Left, __assign({}, leftProps)),
            React.createElement(ChipLabel, { className: getClassName(CHIP_LABEL) }, label)));
    }));
};
var ChipSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: var(--ws-chip-gap, 4px);\n    padding: var(--ws-chip-gap-padding);\n"], ["\n    display: flex;\n    flex-direction: row;\n    gap: var(--ws-chip-gap, 4px);\n    padding: var(--ws-chip-gap-padding);\n"])));
var ChipLabel = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: var(--ws-chip-label-width);\n    display: inline-block;\n    white-space: nowrap\n"], ["\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: var(--ws-chip-label-width);\n    display: inline-block;\n    white-space: nowrap\n"])));
var templateObject_1, templateObject_2;
